import React from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'Components/Collapsible'

import ExtraDescription from './components/ExtraDescription'

import { _CollapseContainer, collapseLabelCss, collapseContentCss } from './styles'


const emptyFunc = () => {}

const CollapsibleExtraDescription = ({
  title,
  collapsibleTitle,
  descriptions,
  mobileBrowser,
  hideIntro = false,
  getCollapsibleState = emptyFunc,
  isAddressPage,
  collapsibleIdSuffix,
}) => (
  <div>
    {!mobileBrowser ? (
      <ExtraDescription
        title={title}
        descriptions={descriptions}
        hideIntro={hideIntro}
        isAddressPage={isAddressPage}
      />
    ) : (
      <_CollapseContainer isAddressPage={isAddressPage}>
        <Collapsible
          showSeparatorLine={false}
          inputId={`ReadMoreExtra-${collapsibleIdSuffix}`}
          htmlFor={'ReadMoreExtra'}
          title={collapsibleTitle}
          getCollapsibleState={getCollapsibleState}
          defaultShowState
          customClasses={
            {
              collapseLabel: collapseLabelCss,
              collapseContent: collapseContentCss,
            }
          }
        >
          <ExtraDescription
            title={title}
            descriptions={descriptions}
            hideIntro={hideIntro}
            isAddressPage={isAddressPage}
          />
        </Collapsible>
      </_CollapseContainer>
    )}
  </div>
)

CollapsibleExtraDescription.propTypes = {
  title: PropTypes.string,
  collapsibleTitle: PropTypes.string,
  descriptions: PropTypes.shape({
    intro: PropTypes.string,
    whats_nearby: PropTypes.string,
    getting_around: PropTypes.string,
  }),
  mobileBrowser: PropTypes.bool,
  hideIntro: PropTypes.bool,
  getCollapsibleState: PropTypes.func,
  isAddressPage: PropTypes.bool,
  collapsibleIdSuffix: PropTypes.string,
}

export default CollapsibleExtraDescription
